// extracted by mini-css-extract-plugin
export default {"list":"Tree_list__SAtvK"};